import { render, staticRenderFns } from "./His.vue?vue&type=template&id=3ab5e3c9&scoped=true"
import script from "./His.vue?vue&type=script&lang=ts"
export * from "./His.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab5e3c9",
  null
  
)

export default component.exports